import { Grid, Typography } from "@mui/material";
import styled from "styled-components";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export const SGridContainer = styled(Grid)<{ $isExpanded: boolean }>`
  && {
    background-color: ${({ theme }) => theme.colors.bgGray};
    padding-left: 32px;
    display: flex;
    flex-direction: ${({ $isExpanded }) => ($isExpanded ? "row" : "column")};
    height: 100%;
    padding: 0;
    box-shadow: -3px 3px 6px rgba(0, 0, 0, 0.1);
  }
`;

export const SGridCard = styled(Grid)<{ $isExpanded: boolean }>`
  && {
    background-color: white;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
    height: ${({ $isExpanded }) => ($isExpanded ? "100%" : "231px")};
    margin: 0;
    padding: 0;
    margin-top: ${({ $isExpanded }) => ($isExpanded ? "" : "45")};
    margin-right: 0;
    padding-bottom: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: ${({ $isExpanded }) => ($isExpanded ? "50%" : "")};
  }
`;

export const SGridRow1 = styled(Grid)<{ $isExpanded: boolean }>`
  && {
    display: ${({ $isExpanded }) => ($isExpanded ? "block" : "flex")};
    margin: 0;
    padding: 0;
    height: ${({ $isExpanded }) => ($isExpanded ? "60%" : "80%")};
    width: 100%;
  }
`;

export const SGridRow2 = styled(Grid)<{ $isExpanded: boolean }>`
  && {
    display: ${({ $isExpanded }) => ($isExpanded ? "block" : "flex")};
    width: ${({ $isExpanded }) => ($isExpanded ? "" : "100%")};
    margin: 0;
    padding: 0;
    height: 20%;
    grid-gap: 32px;
    align-items: center;
    justify-content: center;
  }
`;

export const SEmptyInput = styled(Grid)`
  && {
    background-color: ${({ theme }) => theme.colors.bgGray};
    width: 155px;
    height: 36px;
    border-radius: 4px;
  }
`;

export const SGridImg = styled(Grid)`
  && {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const SCardImg = styled.img`
  && {
    z-index: 1000;
    background-color: white;
  }
`;

export const SGridDescript = styled(Grid)<{ $isExpanded: boolean }>`
  && {
    width: 100%;
    display: flex;
    justify-content: ${({ $isExpanded }) =>
      $isExpanded ? "center" : "flex-start"};
    align-items: center;
    flex-direction: column;
    height: ${({ $isExpanded }) => ($isExpanded ? "" : "100%")};
    padding: ${({ $isExpanded }) => ($isExpanded ? "20px" : "")};
  }
`;

export const SGridAssets = styled(Grid)<{ $isExpanded: boolean }>`
  && {
    padding-top: 12px;
    padding-left: 32px;
    padding-right: 32px;
    padding-bottom: 8px;
    width: ${({ $isExpanded }) => ($isExpanded ? "100%" : "")};
  }
`;

export const SHeader = styled(Typography)<{ $isExpanded: boolean }>`
  && {
    color: ${({ theme }) => theme.colors.textGray};
    font-family: ${({ theme }) => theme.fonts.primary};
    font-weight: 600;
    font-style: normal;
    font-size: 14px;
    line-height: 19px;
    margin-top: 24px;
    padding: 0;
    width: 100%;
    display: ${({ $isExpanded }) => ($isExpanded ? "flex" : "block")};
    justify-content: ${({ $isExpanded }) => ($isExpanded ? "center" : "")};
  }
`;

export const SHeader2 = styled(Typography)`
  && {
    color: ${({ theme }) => theme.colors.textGray};
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-size: 12px;
    line-height: 16px;
    margin-top: 8px;
  }
`;

export const SMessage = styled(Typography)<{ $isExpanded: boolean }>`
  && {
    color: ${({ theme }) => theme.colors.textGray};
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-size: 12px;
    line-height: 20px;
    margin-top: 8px;
    padding-right: ${({ $isExpanded }) => ($isExpanded ? "" : "32px")};
    text-align: ${({ $isExpanded }) => ($isExpanded ? "center" : "")};
  }
`;

export const SEmptyBox = styled(Typography)`
  && {
    color: ${({ theme }) => theme.colors.textGray};
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-size: 12px;
    line-height: 16px;
    margin-top: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 151px;
    border: 1px dashed ${({ theme }) => theme.colors.textGray};
  }
`;

export const SExpandMoreIcon = styled(ExpandMoreIcon)`
  && {
    font-size: 24px;
  }
`;
